define('glu/grid/gridLayout',['require','../collection','../dialog','../locale','../util','./sectionLayout','./column/column','./body/tableCaption','./header/tableHeader','./tableLayout','./header/tableHeaderLayout','./footer/tableFooterLayout','./paginate/pager','./paginate/serverSidePager','./footer/bulkActions','./filter/dynamicTypeSearch','./manageColumns/manageColumns','./savedViews/savedViews','./savedViews/components/savedViewsCollection','./filter/filterProcessor','./filter/singularFilterProcessor','./filter/exclusiveFilterProcessor','./filter/badges/filterBadgesRow','./filter/badges/filterBadgesRow','./filter/badges/filterBadgesHeaderLayout','./state/stateModel','./multiColumnSort/multiColumnSortView','./comparatorFactory','./gridDefaultOptions'],function(require) {
    'use strict';

    var Collection = require('../collection'),
        dialog = require('../dialog'),
        locale = require('../locale'),
        util = require('../util'),
        SectionLayout = require('./sectionLayout'),
        ColumnView = require('./column/column'),
        TableCaptionView = require('./body/tableCaption'),
        TableHeaderView = require('./header/tableHeader'),
        TableLayout = require('./tableLayout'),
        TableHeaderLayout = require('./header/tableHeaderLayout'),
        TableFooterLayout = require('./footer/tableFooterLayout'),
        PagerView = require('./paginate/pager'),
        ServerSidePagerView = require('./paginate/serverSidePager'),
        BulkActionsView = require('./footer/bulkActions'),
        SearchView = require('./filter/dynamicTypeSearch'),
        ManageColumnsView = require('./manageColumns/manageColumns'),
        SavedViews = require('./savedViews/savedViews'),
        SavedViewsCollection = require('./savedViews/components/savedViewsCollection'),
        FilterProcessor = require('./filter/filterProcessor'),
        SingularFilterProcessor = require('./filter/singularFilterProcessor'),
        ExclusiveFilterProcessor = require('./filter/exclusiveFilterProcessor'),
        FilterBadgeRowView = require('./filter/badges/filterBadgesRow'),
        FilterBadgeView = require('./filter/badges/filterBadgesRow'),
        FilterBadgeHeaderView = require('./filter/badges/filterBadgesHeaderLayout'),
        StateModel = require('./state/stateModel'),
        MultiColumnSortView = require('./multiColumnSort/multiColumnSortView'),
        comparatorFactory = require('./comparatorFactory'),
        defaultOptions = require('./gridDefaultOptions');

    return SectionLayout.extend({
        className: 'grid',
        gridCollection: false,
        pageCollection: false,
        filterCollection: false,
        filterView: false,
        pagerView: false,
        tableView: false,
        tableBody: false,
        tableHeader: false,
        bulkActionsViewClass: BulkActionsView,
        filterViewClass: SearchView,
        tableViewClass: TableLayout,
        tableBodyClass: ColumnView,
        tableCaptionClass: TableCaptionView,
        tableHeaderClass: TableHeaderView,
        tableHeaderLayoutClass: TableHeaderLayout,
        tableFooterLayoutClass: TableFooterLayout,
        filterBadgeRowViewClass: FilterBadgeRowView,
        filterBadgeViewClass: FilterBadgeView,
        defaultOptions: defaultOptions,

        /**
         * @param options
         */
        initialize: function(options) {

            SectionLayout.prototype.initialize.apply(this, arguments);

            // Need to keep reference to options due to build process on grid render
            options = options || {};
            this.options = options;

            if (!this.options.collection && !this.options.filter) {
                throw new Error(locale.get('gridNotProvideFilteringMsg'));
            }

            util.defaults(this.options, this.defaultOptions);

            this.masterCollection = this.options.collection;
            this.gridCollection = this.options.collection;

            if (this.options.trackState) {
                this.stateModel = this.createStateModel(this.options.trackState, this.options.state);
            } else {
                this.stateModel = null;
            }

            this.captureState = this.options.captureState;

            // Set the legacy pagination options based on `pageable`.
            if (this.options.pageable) {
                this.options.paginateMethod = this.options.pageable.method;
                this.options.serverSidePagination = !!this.options.pageable.method;
                this.options.clientSidePagination = (this.options.pageable === true) || !this.options.pageable.server;
                this.options.paginate = this.options.pageable.type || 'advanced';
                this.options.pageSize = this.options.pageable.pageSize || 50;
                this.options.pageSizeValues = this.options.pageable.pageSizeValues || [5, 10, 25, 50, 100, 250];
            }

            this.pagerViewClass = options.serverSidePagination ?
                ServerSidePagerView :
                PagerView;

            //pager defaults to the footer, can be set on subclass or in options with options taking precedence
            this.pagerLocation = this.options.pagerLocation || this.pagerLocation || 'footer';

            this.disableDynamicColumnWidths = this.options.disableDynamicColumnWidths;

            this.hasStickyFooter = this.pagerLocation === 'footer' && this.options.stickyFooter;

            // if savedViews functionality are enabled than we should initialize stateModel.
            if (!util.isEmpty(this.options.savedViews)) {
                this.options.trackState = true;
                this.stateModel = this.createStateModel(this.options.trackState, this.options.state);
                // eslint-disable-next-line new-cap
                this.savedViewsCollection = new this.options.savedViewsCollection(null, {
                    gridName: this.options.savedViews.gridName,
                    stateModel: this.stateModel,
                    storage: this.options.savedViews.storage
                });
            }

            //we need this to keep initial options (default sorting, pageSize, etc.)
            this.initialOptions = util.extend({}, this.options);
            this.setDefaultHiddenColumns();
        },

        templateHelpers: function() {
            return {
                disableDynamicColumnWidths: this.disableDynamicColumnWidths,
                showLoaderOnFilter: this.options.showLoaderOnFilter
            };
        },

        onClose: function() {
            //should close all table views
            if (this.tableCaption) {
                this.tableCaption.close();
            }
            if (this.tableHeader) {
                this.tableHeader.close();
            }
            if (this.tableBody) {
                this.tableBody.close();
            }

            if (this.filterView) {
                this.filterView.close();
            }

            if (this.filterProc) {
                this.filterProc.close();
            }
        },

        onBeforeRender: function() {
            this.build();
        },

        build: function() {
            this.triggerMethod('before:build', this);

            if (!this.usedSelectedView) {
                this.loadDefaultSavedView();
            }

            if (this.options.filterable || this.options.filter) {
                this.buildFilterView();
            }

            if (this.options.paginate) {
                this.buildPagerView();
            }

            if (this.options.filterable || (this.options.filter && this.options.badge !== false)) {
                this.buildFilterBadgeView();
                this.buildFilterBadgeRowView();
                this.buildFilterBadgeHeaderView();
            }

            this.buildHeaderLayout();
            this.buildManageColumnsLayout();
            this.buildSavedViewsLayout();
            this.buildFooterLayout();
            this.buildTableView();
            this.addListeners();
            this.triggerMethod('build', this);
            this.postBuild();
            this.triggerMethod('after:build', this);
        },

        /**
         * The header layout can be specified by the consumer during init.  The standard layout supports filtering,
         * advanced search, etc.  The small screen version supports single textbox searching, etc.
         *
         */
        buildHeaderLayout: function() {
            var TableHeaderLayoutClass = this.tableHeaderLayoutClass;

            this.headerLayout = new TableHeaderLayoutClass();

            if (this.pagerLocation === 'header' && this.pagerView) {
                this.headerLayout.setPager(this.pagerView);
            }
        },

        buildManageColumnsLayout: function() {
            this.manageColumnsLayout = new ManageColumnsView({
                columns: this.columns,
                filterProcessor: this.filterProc,
                grid: this
            });
        },

        buildSavedViewsLayout: function() {
            if (util.isEmpty(this.options.savedViews) || !this.savedViewsCollection) {
                return;
            }

            this.savedViews = new SavedViews({
                grid: this,
                collection: this.savedViewsCollection,
                stateModel: this.stateModel
            });
        },

        buildFooterLayout: function() {
            var TableFooterLayoutClass = this.tableFooterLayoutClass,
                BulkActionsViewClass = this.bulkActionsViewClass;

            this.footerLayout = new TableFooterLayoutClass({
                hasStickyFooter: this.hasStickyFooter,
                grid: this
            });

            if (this.pagerLocation === 'footer' && this.pagerView) {
                this.footerLayout.setPager(this.pagerView);
            }

            this.footerLayout.setBulkActions(new BulkActionsViewClass({
                bulkActions: this.options.bulkActions,
                columns: this.columns,
                getSelectedRows: this.getSelectedRows.bind(this),
                getSelectedRowModels: this.getSelectedRowModels.bind(this),
                gridCid: this.cid
            }));
        },

        buildFilterView: function() {
            var opts = this.options;
            //filteredCollection can be used later as an input to another process in the pipeline, paging for example
            //gridCollection is the collection used to show the visible grid rows and will be the same unless
            //there is paging or another downstream process that changes it.
            this.filteredCollection = new Collection(opts.collection.models);
            this.gridCollection = this.filteredCollection;

            // Support both legacy `filterMethod` and `filterable.method` solution
            if (!opts.filterMethod) {
                opts.filterMethod = opts.filterable && opts.filterable.method ? util.bind(opts.filterable.method, this.masterCollection) : undefined;
            }

            if (opts.filter && opts.badge === false) {
                this.filterProc = new SingularFilterProcessor({
                    inputCollection: this.masterCollection,
                    outputCollection: this.filteredCollection,
                    filterMethod: opts.filterMethod,
                    stateModel: this.stateModel,
                    columns: this.columns
                });
            } else if (opts.filter === 'multi' && opts.badge) {
                this.filterProc = new FilterProcessor({
                    inputCollection: this.masterCollection,
                    outputCollection: this.filteredCollection,
                    filterMethod: opts.filterMethod,
                    stateModel: this.stateModel,
                    columns: this.columns
                });
            } else {
                this.filterProc = new ExclusiveFilterProcessor({
                    inputCollection: this.masterCollection,
                    outputCollection: this.filteredCollection,
                    filterMethod: opts.filterMethod,
                    stateModel: this.stateModel,
                    columns: this.columns
                });
            }

            var FilterViewClass = this.filterViewClass;

            this.filterView = new FilterViewClass({
                collection: this.columns,
                filterViewClass: this.filterViewClass,
                filterProc: this.filterProc,
                filtersCollection: this.filterProc.filters,
                masterCollection: this.masterCollection,
                gridSearch: opts.gridSearch,
                disableAuxControl: !opts.disableAuxControl,
                grid: this
            });
        },

        disableFilterView: function() {
            this.filterView.disable();
        },

        enableFilterView: function() {
            this.filterView.enable();
        },

        toggleFilterView: function() {
            this.filterView.toggle();
        },

        buildFilterBadgeView: function() {
            this.filterBadgeView = new FilterBadgeView({
                columns: this.columns,
                filters: this.filterProc.filters
            });

        },

        buildFilterBadgeRowView: function() {
            if (!this.options.columnBadges) {
                return;
            }

            this.filterBadgeRowView = new FilterBadgeRowView({
                columns: this.columns,
                filters: this.filterProc.filters
            });
        },

        buildFilterBadgeHeaderView: function() {
            this.filterBadgeHeaderView = new FilterBadgeHeaderView({
                columns: this.columns,
                masterCollection: this.masterCollection,
                filters: this.filterProc.filters,
                filterProc: this.filterProc
            });
        },

        buildPagerView: function() {
            var opts = this.options;
            // if we have a filter then we need to have the pager page the output of the filters and render that
            // otherwise the filters will never apply, this also improves sorting performance (see buildTableView() below)
            var pagerInputCollection = this.filteredCollection || this.masterCollection,
                PagerViewClass = this.pagerViewClass;

            // bypass the 11.22 release changes if server side paging is active
            if (opts.serverSidePagination) {
                pagerInputCollection = this.masterCollection;
            }

            this.gridCollection = new Collection();

            this.pagerView = new PagerViewClass({
                inputCollection: pagerInputCollection,
                outputCollection: this.gridCollection,
                type: opts.paginate,
                pageSize: opts.pageSize,
                currentPage: opts.currentPage,
                pageSizeValues: opts.pageSizeValues,
                paginateMethod: opts.paginateMethod,
                stateModel: this.stateModel,
                resultsName: opts.resultsName
            });

            this.pagerView.slice();
        },

        buildTableView: function() {
            var opts = this.options;

            // Set default values as required
            opts = util.defaults(opts, {
                sortable: true,
                filterable: true,
                resizable: true,
                draggable: true
            });

            // Support legacy options
            if (opts.sorting !== undefined) {
                opts.sortable = opts.sorting;
            }

            if (opts.filtering !== undefined) {
                opts.filterable = opts.filtering;
            }

            if (opts.resizing !== undefined) {
                opts.resizable = opts.resizing;
            }

            if (opts.reordering !== undefined) {
                opts.draggable = opts.reordering;
            }

            var TableView = this.tableViewClass;
            var TableCaption = this.tableCaptionClass;
            var TableHeader = this.tableHeaderClass;
            var TableBody = this.tableBodyClass;

            //default to sorting the output of the filter, if it exists
            //this can vastly improve sorting operations as:
            //	we don't have to sort the entire master collection, just the filtered version which is smaller if filtering
            //	we don't have to filter on sort of the master collection
            //	by not sorting data we are going to toss away during filtering anyhow
            //Pipeline is thus: master --> filter --> sort --> page
            var sortableCollection = this.filteredCollection;

            this.tableView = new TableView({
                masterCollection: this.masterCollection,
                emptyViewText: opts.emptyViewText,
                loadingView: opts.loadingView,
                loadingViewText: opts.loadingViewText,
                disableDynamicColumnWidths: opts.disableDynamicColumnWidths,
                serverSidePagination: opts.serverSidePagination,
                grid: this
            });

            this.tableCaption = new TableCaption({
                text: opts.caption
            });

            //if we don't have filtering enabled then the sortable collection will be the master collection
            //unless we have server side paging
            if (!sortableCollection) {
                if (opts.paginate && !opts.serverSidePagination) {
                    sortableCollection = this.masterCollection;
                } else {
                    sortableCollection = this.gridCollection;
                }
            }

            // Support both legacy `sortMethod` and `sortable.method` solution
            if (!opts.sortMethod) {
                opts.sortMethod = opts.sortable && opts.sortable.method ? util.bind(opts.sortable.method, this.masterCollection) : undefined;
            }

            this.tableHeader = new TableHeader({
                gridCid: this.cid,
                collection: opts.columns,
                masterCollection: this.masterCollection,
                sortMethod: opts.sortMethod,
                sortableCollection: sortableCollection,
                clientSidePagination: opts.clientSidePagination || (opts.paginate && !opts.serverSidePagination),
                layout: this,
                filterProcessor: this.filterProc,
                sortable: !!opts.sortable,
                filterable: !!opts.filterable,
                resizable: !!opts.resizable,
                draggable: !!opts.draggable,
                defaultColumnWidth: opts.defaultColumnWidth,
                defaultSort: opts.defaultSort,
                disableDynamicColumnWidths: opts.disableDynamicColumnWidths,
                stateModel: this.stateModel,
                grid: this,
                enableColumnRename: opts.enableColumnRename,
                stateFilters: opts.state && opts.state.filters
            });

            this.tableBody = new TableBody({
                gridCid: this.cid,
                grid: this,
                collection: this.gridCollection,
                columns: opts.columns,
                rowClassName: opts.rowClassName,
                groupBy: opts.groupBy,
                editOptions: opts.editOptions,
                rowSubView: opts.rowSubView,
                rowSubViewOptions: opts.rowSubViewOptions,
                disableDynamicColumnWidths: opts.disableDynamicColumnWidths
            });
        },

        onTableViewClientSidePaginationSort: function() {
            this.pagerView.handleFirstPageClick();
        },

        changeCurrentPage: function(pageNumber) {
            if (this.pagerView.currentPage !== pageNumber) {
                this.pagerView.handlePageSelect(pageNumber);
            }
        },

        buildMultiColumnSortView: function() {
            var multiColumnSort = this.options.multiColumnSort,
                multiColumnSortState = false;


            if (this.stateModel && this.stateModel.has('multiColumnSort')) {
                multiColumnSortState = this.stateModel.get('multiColumnSort');
            }

            if (this.options.multiColumnSort === true) {
                multiColumnSort = {};
            }

            var multiColumnSortViewOptions = util.extend({
                columnCollection: this.columns,
                grid: this,
                multiColumnSortState: multiColumnSortState
            }, multiColumnSort);

            this.multiColumnSortView = new MultiColumnSortView(multiColumnSortViewOptions);

            return this.multiColumnSortView;
        },

        applyMultiColumnSort: function(sortingCollection) {
            // Clear current one column sort
            this.columns.each(function(model) {
                model.set({
                    sorted: false,
                    sort: false
                });
            });

            var multiColumnSortCollection = this.filteredCollection.clone(),
                comparator = comparatorFactory.multiColumnComparator(sortingCollection);

            multiColumnSortCollection.comparator = comparator;

            multiColumnSortCollection.sort({
                comparator: comparator
            });

            this.filteredCollection.comparator = null;

            this.filteredCollection.set(multiColumnSortCollection.toJSON());

            if (this.filterProc.filters.length) {
                this.listenToOnce(this.filterProc.filters, 'remove', function() {
                    this.applyMultiColumnSort(sortingCollection);
                }, this);
            }

            if (this.stateModel) {
                this.stateModel.setMultiColumnSort(sortingCollection.toJSON().map(function(column) {
                    return column.field;
                }), true);
            }

        },

        unApplyMultiColumnSort: function() {
            if (this.options.defaultSort) {
                this.tableHeader.initDefaultSort(this.options);
            } else {
                this.filteredCollection.set(this.options.collection.toJSON());
                this.filterProc.process();
            }

            if (this.stateModel) {
                this.stateModel.setMultiColumnSort(null, false);
            }

            this.stopListening(this.filterProc.filters, 'remove');

        },

        postBuild: function() {
            if (this.filterBadgeView) {
                this.headerLayout.setFilterBadges(this.filterBadgeView);
            }

            if (this.filterView) {
                this.headerLayout.setFilters(this.filterView);
            }

            if (this.savedViews) {
                this.headerLayout.setSavedViews(this.savedViews);
            }

            if (this.options.multiColumnSort) {
                this.headerLayout.setMultiColumnSort(this.buildMultiColumnSortView());
            }

            if (this.filterBadgeRowView) {
                this.tableBody.setFirstView(this.filterBadgeRowView);
            } else if (this.options.bodyFirstView) {
                this.tableBody.setFirstView(this.options.bodyFirstView);
            }

            if (this.filterBadgeHeaderView) {
                this.headerLayout.setFilterBadgeHeader(this.filterBadgeHeaderView);
            }

            this.tableView.setCaption(this.tableCaption);

            this.tableView.setHeader(this.tableHeader);

            this.tableView.setBody(this.tableBody);

            this.setHeader(this.headerLayout);

            this.setFooter(this.footerLayout);

            this.setContent(this.tableView);

            this.setManageColumns(this.manageColumnsLayout);
        },

        // Return an array of all selected rows in the grid.
        // Note: there may be a more appropriate home for this function.  For now it is most convenient to
        // expose this at the grid layout level.
        getSelectedRows: function() {
            var selectedRows = [];
            this.$el.find('.column-row-selector:checked').each(function() {
                selectedRows.push({
                    cid: this.getAttribute('data-model-cid')
                });
            });
            return selectedRows;
        },

        getSelectedRowModels: function() {
            return util.map(this.getSelectedRows(), function(row) {
                return this.masterCollection.get(row.cid);
            }, this);
        },

        handleFilter: function(filter) {
            this.filterProc.addFilter(filter);
        },

        handleDelete: function(view) {
            this.masterCollection.remove(view.model);
        },

        setPageSize: function(pageSize) {
            if (!pageSize) {
                return;
            }

            if (!util.isNullOrUndefined(this.options.pageable)) {
                util.extend(this.options.pageable, {
                    pageSize: pageSize
                });
            }

            util.extend(this.options, {
                pageSize: pageSize
            });
        },

        setCurrentPage: function(currentPage) {
            if (!currentPage) {
                return;
            }

            util.extend(this.options, {
                currentPage: currentPage
            });
        },

        setSort: function(sort) {
            if (util.isEmpty(sort)) {
                this.options.defaultSort = this.initialOptions.defaultSort || {};
                return false;
            }

            var field = Object.keys(sort)[0];

            this.options.defaultSort = {
                field: field,
                order: sort[field]
            };
        },
        /**
         * Sorts column collection in order defined by columnOrder and
         * appends other unsorted columns(that was not found in columnOrder array) to the end
         */
        setColumnOrder: function(columnOrder) {
            if (!columnOrder) {
                return;
            }

            var sorted = new Array(columnOrder.length),
                unsorted = [];

            util.each(this.options.columns, function(column) {
                var idx = columnOrder.indexOf(column.field);
                //if found puts by same index defined in columnOrder
                if (idx !== -1) {
                    sorted[idx] = column;
                } else {
                    unsorted.push(column);
                }
            });

            this.options.columns = sorted.concat(unsorted);
        },

        setHiddenColumns: function(hiddenColumns) {
            if (!hiddenColumns) {
                return;
            }

            util.each(this.options.columns, function(column) {
                if (typeof column.condition !== 'function') {
                    column.condition = (hiddenColumns.indexOf(column.field) === -1);
                } else if (!hiddenColumns.length) {
                    column.condition = true;
                }
            });
        },

        setFiltersBeforeBuild: function(filters) {
            this.listenTo(this, 'build', function() {
                util.each(filters, function(value, prop) {
                    this.options.collection.trigger('grid:filter:' + prop, value);
                }, this);

                this.trigger('state:filters:loaded');
            });
        },


        convertStateToObject: function(array) {
            return {
                'pageSize': array[0],
                'currentPage': array[1],
                'sort': array[2],
                'columnOrder': array[3],
                'hiddenColumns': array[4],
                'filters': array[5],
                'multiColumnSort': array[6]
            };
        },

        loadStateObject: function() {
            var state = this.options.state || {};

            if (util.isEmpty(state)) {
                return this.initColumns();
            }

            if (typeof this.options.columns.toJSON === 'function') {
                this.options.columns = this.options.columns.toJSON();
            }

            if (Array.isArray(state)) {
                state = this.convertStateToObject(state);
            }

            this.setPageSize(state.pageSize);

            this.setCurrentPage(state.currentPage);

            this.setSort(state.sort);

            this.setColumnOrder(state.columnOrder);

            this.setHiddenColumns(state.hiddenColumns);

            this.setFiltersBeforeBuild(state.filters);

            this.initColumns();
        },

        initColumns: function() {
            // Support columns as an Array or Collection
            this.options.columns = util.isArray(this.options.columns) ? new Collection(this.options.columns) : this.options.columns;

            this.columns = this.options.columns;
        },

        createStateModel: function(trackState, state) {
            if (trackState === true) {
                trackState = {};
            }

            if (!util.isEmpty(state)) {
                if (Array.isArray(state)) {
                    state = this.convertStateToObject(state);
                    trackState.array = true;
                }
                util.extend(trackState, state);
            }

            var model = new StateModel(trackState, {
                grid: this,
                array: trackState.array || false
            });

            if (util.isEmpty(state.filters)) {
                model.onFiltersLoaded();
            }

            return model;
        },

        loadDefaultSavedView: function() {
            if (util.isEmpty(this.options.savedViews) || !this.savedViewsCollection) {
                return this.loadStateObject();
            }
            var defaultModel = this.savedViewsCollection.getDefaultModel();

            this.loadSavedView(defaultModel);
        },

        loadSavedView: function(model) {
            var opts = {
                silent: true
            };

            this.options.state = model.toJSON() || {};

            if (this.stateModel) {
                this.stateModel.clear(opts).set(this.options.state, opts);
            }

            return this.loadStateObject();
        },

        fullGridUpdate: function(model) {
            this.usedSelectedView = true;
            this.close();
            this.loadSavedView(model);
            this.render();
            this.trigger('grid:fully:updated', this, model);
        },

        addListeners: function() {
            if (this.savedViews) {
                this.listenTo(this.savedViews, 'grid:use:savedView', this.fullGridUpdate);
            }

            if (this.filterView) {
                this.listenTo(this.filterView, 'filter', this.handleFilter);
            }

            if (this.multiColumnSortView) {
                this.listenTo(this, 'tableView:clientSidePagination:sort', function() {
                    this.multiColumnSortView.trigger('turnOff');
                });
            }

            if (this.tableBody) {
                this.listenTo(this.tableBody, 'itemview:delete', this.handleDelete);
            }

            if (this.stateModel) {
                this.listenTo(this, {
                    'build': function() {
                        this.listenTo(this.columns, {
                            'change:condition': function() {
                                this.stateModel.setHiddenColumns(this.columns.toJSON());
                            },
                            'change:width': function() {
                                this.stateModel.setColumnWidths(this.columns.toJSON());
                            }
                        });
                    },
                    'state:filters:loaded': function() {
                        this.stateModel.onFiltersLoaded();
                    }
                });
            }
        },

        // added this function to check initial hidden columns in the columns properties.
        setDefaultHiddenColumns: function() {
            var columns = util.isArray(this.options.columns) ? new Collection(this.options.columns) : this.options.columns;

            var hiddenColumns = util.map(util.where(columns.toJSON(), {
                condition: false
            }), function(column) {
                return column.field;
            });

            if (!this.stateModel || this.stateModel.get('hiddenColumns').length) {
                return false;
            }

            // use silent to avoid triggering update on initial grid state
            this.stateModel.set('hiddenColumns', hiddenColumns || [], {
                silent: true
            });
        },

        /**
         * Filters the grid on the given filter(s).
         * @param filters Array of filters to add to the grid or a rest-style array of filters
         * @example grid.filter({
         *            filterField: 'someField',
         *            filterValue: 'someValue'
         *          }, {
         *            filterField: 'secondField',
         *            filterValue: 'secondValue'
         *          });
         */
        filter: function(filters) {
            if (!util.isArray(filters)) {
                filters = util.toArray(arguments);
            }

            filters.forEach(function(filter) {
                var filterField = filter.filterField,
                    filterValue = filter.filterValue;
                this.collection.trigger('grid:filter:' + filterField, filterValue);
            }.bind(this));
        }
    });
});

